<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="B2865, M5255, M5270, MS725, MS821, MS822, MS823, MS825, MS826 Printers">
     B2865, M5255, M5270, MS725, MS821, MS822, MS823, MS825, MS826 Printers
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety-information-chapter.html#safety-information-chapter" title="Safety information">
     Safety information
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Conventions">
      Conventions
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e43" title="Product statements">
      Product statements
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter" title="Learning about the printer">
     Learning about the printer
    </a>
   </p>
   <div id="divd0e225">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer" title="Finding information about the printer">
      Finding information about the printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer" title="Selecting a location for the printer">
      Selecting a location for the printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations" title="Printer configurations">
      Printer configurations
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables" title="Attaching cables">
      Attaching cables
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="using-cs321-printer-model-chapter.html#using-cs321-printer-model-chapter" title="Using the control panel">
     Using the control panel
    </a>
   </p>
   <div id="divd0e685">
    <p class="toc-2-style">
     <a href="using-control-panel-2-4-topic.html#using-control-panel-2-4" title="Lexmark B2865, MS725, MS821, MS823, and MS825 printers">
      <strong>
       Lexmark B2865, MS725, MS821, MS823, and MS825 printers
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-4.3-topic.html#using-control-panel-4.3" title="Lexmark M5255, M5270, MS822, and MS826 printers">
      <strong>
       Lexmark M5255, M5270, MS822, and MS826 printers
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light" title="Understanding the status of the power button and indicator light">
      Understanding the status of the power button and indicator light
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-and-using-home-screen-applications-chapter.html#setting-up-and-using-home-screen-applications-chapter" title="Setting up and using the home screen applications">
     Setting up and using the home screen applications
    </a>
   </p>
   <div id="divd0e1001">
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen" title="Using the home screen">
      Using the home screen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen" title="Customizing the home screen">
      Customizing the home screen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#using-display-customization" title="Using Display Customization">
      Using Display Customization
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-eco-settings-topic.html#configuring-eco-settings" title="Configuring Eco-Settings">
      Configuring Eco-Settings
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-device-quotas-topic.html#setting-up-device-quotas" title="Setting up Device Quotas">
      Setting up Device Quotas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-qr-code-generator-topic.html#using-qr-code-generator" title="Using QR Code Generator">
      Using QR Code Generator
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-customer-support-topic.html#using-customer-support" title="Using Customer Support">
      Using Customer Support
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-bookmarks-topic.html#d0e1300" title="Managing bookmarks">
      Managing bookmarks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-contacts-topic.html#d0e1377" title="Managing contacts">
      Managing contacts
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-and-using-accessibility-features-chapter.html#setting-up-and-using-accessibility-features-chapter" title="Setting up and using the accessibility features">
     Setting up and using the accessibility features
    </a>
   </p>
   <div id="divd0e1496">
    <p class="toc-2-style">
     <a href="enabling-magnification-mode-topic.html#enabling-magnification-mode" title="Enabling Magnification mode">
      Enabling Magnification mode
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#activating-voice-guidance" title="Activating Voice Guidance">
      Activating Voice Guidance
     </a>
    </p>
    <p class="toc-2-style">
     <a href="navigating-screen-using-gestures-topic.html#navigating-screen-using-gestures" title="Navigating the screen using gestures">
      Navigating the screen using gestures
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-voice-guidance-speech-rate-topic.html#adjusting-voice-guidance-speech-rate" title="Adjusting the Voice Guidance speech rate">
      Adjusting the Voice Guidance speech rate
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-keyboard-on-display-topic.html#using-keyboard-on-display" title="Using the keyboard on the display">
      Using the keyboard on the display
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-spoken-passwords-or-personal-identifcation-numbers-topic.html#enabling-spoken-passwords-or-personal-identifcation-numbers" title="Enabling spoken passwords or personal identification numbers">
      Enabling spoken passwords or personal identification numbers
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter" title="Loading paper and specialty media">
     Loading paper and specialty media
    </a>
   </p>
   <div id="divd0e1706">
    <p class="toc-2-style">
     <a href="setting-paper-size-type-topic.html#setting-paper-size-type" title="Setting the size and type of the specialty media">
      Setting the size and type of the specialty media
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-topic.html#configuring-universal-paper-settings" title="Configuring Universal paper settings">
      Configuring Universal paper settings
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-250-550-tray-topic.html#loading-250-550-tray" title="Loading the 250- or 550-sheet tray">
      Loading the 250- or 550-sheet tray
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-2100-sheet-tray-topic.html#loading-2100-sheet-tray" title="Loading the 2100-sheet tray">
      Loading the 2100-sheet tray
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder" title="Loading the multipurpose feeder">
      Loading the multipurpose feeder
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays" title="Linking trays">
      Linking trays
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="supported-paper-sizes-types-and-weights-chapter.html#supported-paper-sizes-types-and-weights-chapter" title="Paper support">
     Paper support
    </a>
   </p>
   <div id="divd0e2103">
    <p class="toc-2-style">
     <a href="supported-paper-sizes-ms820-topic.html#supported-paper-sizes-ms820" title="Supported paper sizes">
      Supported paper sizes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-types-gdw-topic.html#supported-paper-types-gdw" title="Supported paper types">
      Supported paper types
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-weights-gdw-topic.html#supported-paper-weights-gdw" title="Supported paper weights">
      Supported paper weights
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter" title="Printing">
     Printing
    </a>
   </p>
   <div id="divd0e4351">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2" title="Printing from a computer">
      Printing from a computer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e4377" title="Printing from a mobile device">
      Printing from a mobile device
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive" title="Printing from a flash drive">
      Printing from a flash drive
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types" title="Supported flash drives and file types">
      Supported flash drives and file types
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs" title="Configuring confidential jobs">
      Configuring confidential jobs
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs" title="Printing confidential and other held jobs">
      Printing confidential and other held jobs
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-lis" title="Printing a font sample list">
      Printing a font sample list
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2" title="Printing a directory list">
      Printing a directory list
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter" title="Understanding the printer menus">
     Understanding the printer menus
    </a>
   </p>
   <div id="divd0e4856">
    <p class="toc-2-style">
     <a href="menus-map-mfp-topic.html#menus-map-mfp" title="Menu map">
      Menu map
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e5107" title="Device">
      Device
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e6597" title="Print">
      Print
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e7594" title="Paper">
      Paper
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-print-topic.html#d0e7806" title="USB Drive">
      USB Drive
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e7967" title="Network/Ports">
      Network/Ports
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e9807" title="Security">
      Security
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e10774" title="Reports">
      Reports
     </a>
    </p>
    <p class="toc-2-style">
     <a href="help-topic.html#help" title="Help">
      Help
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-group.html#d0e10979" title="Troubleshooting">
      Troubleshooting
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-h1-topic.html#printing-menu-settings-page-h1" title="Printing the Menu Settings Page">
      Printing the Menu Settings Page
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-printer-chapter.html#securing-printer-chapter" title="Securing the printer">
     Securing the printer
    </a>
   </p>
   <div id="divd0e11031">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot" title="Locating the security slot">
      Locating the security slot
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory" title="Erasing printer memory">
      Erasing printer memory
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-hard-disk-memory-topic.html#erasing-printer-hard-disk-memory" title="Erasing printer hard disk memory">
      Erasing printer hard disk memory
     </a>
    </p>
    <p class="toc-2-style">
     <a href="encrypting-printer-hard-disk-topic.html#encrypting-printer-hard-disk" title="Encrypting the printer hard disk">
      Encrypting the printer hard disk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings" title="Restoring factory default settings">
      Restoring factory default settings
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2" title="Statement of Volatility">
      Statement of Volatility
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintaining-printer-chapter.html#maintaining-printer-chapter" title="Maintaining the printer">
     Maintaining the printer
    </a>
   </p>
   <div id="divd0e11252">
    <p class="toc-2-style">
     <a href="adjusting-default-internal-speaker-volume-topic.html#d0e11257" title="Adjusting the speaker volume">
      Adjusting the speaker volume
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e11310" title="Networking">
      Networking
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer" title="Cleaning the printer">
      Cleaning the printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-pick-tires-topic.html#cleaning-pick-tires" title="Cleaning the pick tires">
      Cleaning the pick tires
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group" title="Ordering parts and supplies">
      Ordering parts and supplies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e12234" title="Replacing parts and supplies">
      Replacing parts and supplies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer.html#moving-the-printer" title="Moving the printer">
      Moving the printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e12585" title="Saving energy and paper">
      Saving energy and paper
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#d0e12693" title="Recycling">
      Recycling
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter" title="Clearing jams">
     Clearing jams
    </a>
   </p>
   <div id="divd0e12726">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams" title="Avoiding jams">
      Avoiding jams
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations" title="Identifying jam locations">
      Identifying jam locations
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-trays-topic.html#paper-jam-in-trays" title="Paper jam in trays">
      Paper jam in trays
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-door-a-topic.html#paper-jam-in-door-a" title="Paper jam in door A">
      Paper jam in door A
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-door-c-topic.html#paper-jam-in-door-c" title="Paper jam in door C">
      Paper jam in door C
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-standard-bin-topic.html#paper-jam-in-standard-bin" title="Paper jam in the standard bin">
      Paper jam in the standard bin
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-multipurpose-feeder-topic.html#paper-jam-in-multipurpose-feeder" title="Paper jam in the multipurpose feeder">
      Paper jam in the multipurpose feeder
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-output-expander-topic.html#paper-jam-in-output-expander" title="Paper jam in the output expander">
      Paper jam in the output expander
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-high-capacity-output-expander-topic.html#paper-jam-in-high-capacity-output-expander" title="Paper jam in the high-capacity output expander">
      Paper jam in the high-capacity output expander
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-mailbox-topic.html#paper-jam-in-mailbox" title="Paper jam in the 4-bin mailbox">
      Paper jam in the 4-bin mailbox
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-staple-finisher-topic.html#paper-jam-in-staple-finisher" title="Paper jam in the staple finisher">
      Paper jam in the staple finisher
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-staple-hole-punch-finisher-topic.html#paper-jam-in-staple-hole-punch-finisher" title="Paper jam in the staple, hole punch finisher">
      Paper jam in the staple, hole punch finisher
     </a>
    </p>
    <p class="toc-2-style">
     <a href="staple-jam-in-staple-finisher-topic.html#staple-jam-in-staple-finisher" title="Staple jam in the staple finisher">
      Staple jam in the staple finisher
     </a>
    </p>
    <p class="toc-2-style">
     <a href="staple-jam-in-staple-hole-punch-finisher-topic.html#staple-jam-in-staple-hole-punch-finisher" title="Staple jam in the staple, hole punch finisher">
      Staple jam in the staple, hole punch finisher
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter" title="Troubleshooting">
     Troubleshooting
    </a>
   </p>
   <div id="divd0e13281">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e13284" title="Network connection problems">
      Network connection problems
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e13498" title="Hardware options problems">
      Hardware options problems
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e13644" title="Issues with supplies">
      Issues with supplies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems" title="Paper feed problems">
      Paper feed problems
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems" title="Printing problems">
      Printing problems
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support" title="Contacting customer support">
      Contacting customer support
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-and-migrating-chapter.html#upgrading-and-migrating-chapter" title="Upgrading and migrating">
     Upgrading and migrating
    </a>
   </p>
   <div id="divd0e16770">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e16773" title="Hardware">
      Hardware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-operating-systems-topic.html#d0e17336" title="Software">
      Software
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e17468" title="Firmware">
      Firmware
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices" title="Notices">
     Notices
    </a>
   </p>
   <div id="divd0e17594">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e17597" title="Product information">
      Product information
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e17614" title="Edition notice">
      Edition notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#us-government-rights" title="GOVERNMENT END USERS">
      GOVERNMENT END USERS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks" title="Trademarks">
      Trademarks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices" title="Licensing notices">
      Licensing notices
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels" title="Noise emission levels">
      Noise emission levels
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive" title="Waste from Electrical and Electronic Equipment (WEEE) directive">
      Waste from Electrical and Electronic Equipment (WEEE) directive
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#e-waste-notice" title="India E-Waste notice">
      India E-Waste notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal" title="Product disposal">
      Product disposal
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling" title="Returning Lexmark cartridges for reuse or recycling">
      Returning Lexmark cartridges for reuse or recycling
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice" title="Static sensitivity notice">
      Static sensitivity notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information" title="Temperature information">
      Temperature information
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice" title="Laser notice">
      Laser notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption" title="Power consumption">
      Power consumption
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e17936" title="Applicability of Regulation (EU) 2019/2015 and (EU) 2019/2020">
      Applicability of Regulation (EU) 2019/2015 and (EU) 2019/2020
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e17941" title="Regulatory notices for wireless products">
      Regulatory notices for wireless products
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice" title="Modular component notice">
      Modular component notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation" title="Exposure to radio frequency radiation">
      Exposure to radio frequency radiation
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#industry-canada-en" title="Industry Canada (Canada)">
      Industry Canada (Canada)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e17981" title="European Community (EC) directives conformity">
      European Community (EC) directives conformity
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#federal-communications-commission-fcc-compliance-information-statement-2" title="Federal Communications Commission (FCC) compliance information statement">
      Federal Communications Commission (FCC) compliance information statement
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#notice-to-users-of-class-a-products-in-brazil" title="Aviso aos usu&aacute;rios de produtos Classe A no Brasil.">
      Aviso aos usu&aacute;rios de produtos Classe A no Brasil.
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a" title="European Community (EC) directives conformity">
      European Community (EC) directives conformity
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice" title="Radio interference notice">
      Radio interference notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#statement-of-limited-warranty" title="STATEMENT OF LIMITED WARRANTY FOR LEXMARK LASER PRINTERS, LEXMARK LED PRINTERS, AND LEXMARK MULTIFUNCTION LASER PRINTERS">
      STATEMENT OF LIMITED WARRANTY FOR LEXMARK LASER PRINTERS, LEXMARK LED PRINTERS, AND LEXMARK MULTIFUNCTION LASER PRINTERS
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue